<template>
  <BaseLimitManagement
    :items="items"
    :selected="itemsSelected"
    :loading="loading"
    @delete="deleteSelected"
  >
    <template v-slot:listItem="{ item }">
      <v-checkbox
        :input-value="item.selected"
        @change="selectItem(item)"
      ></v-checkbox>
      <div class="content-wrapper">
        <IsOwnerIndicator
          is-owner
          :tooltip="$t('message.common.yourFacility')"
          height="24px"
          class="mx-3"
        />
        <div>
          <p class="name">{{ item.name }}</p>
          <div class="description">
            <p class="address">
              {{ item.formattedAddress }}
            </p>
            <div v-if="item.storeCode">|</div>
            <p v-if="item.storeCode" class="store-code">
              {{ `${$t("message.common.storeCode")}: ${item.storeCode}` }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </BaseLimitManagement>
</template>

<script>
import IsOwnerIndicator from "@/components/Permissions/IsOwnerIndicator.vue";
import serviceHandler from "@/helpers/handlers/service";
import limitsService from "@/services/limits";
import { FacilityModel } from "@/utils/google/facilities/facility-model";
import BaseLimitManagement from "./BaseLimitManagement.vue";
import { limitsMixin } from "@/helpers/mixins/limits";

export default {
  name: "AddressesLimitManagement",
  components: {
    IsOwnerIndicator,
    BaseLimitManagement
  },
  mixins: [limitsMixin],
  methods: {
    itemsFetchHandler() {
      return limitsService.getFacilities();
    },
    itemDeleteHandler(id) {
      return limitsService.deleteFacility(id);
    },
    async fetchItems() {
      const facilities = await serviceHandler(this.itemsFetchHandler());
      this.items = facilities.map((facility, index) =>
        this.createFacilityModel(facility, index)
      );
    },
    createFacilityModel(facility, itemIndex) {
      const model = new FacilityModel();
      model.makeFacilityModel({ facility, itemIndex });
      return model.returnFacilityModel();
    }
  }
};
</script>

<style lang="scss" scoped>
.content-wrapper {
  display: flex;
  align-items: center;
}

.name {
  @include font-size(14px);
  font-weight: 500;
  margin-top: $spacing * 0.5;
  margin-bottom: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: $dark;
}

.description {
  position: relative;
  display: flex;
  @include font-size(12px);
  font-weight: 400;
  margin-bottom: 0;
  max-width: 100%;
  white-space: nowrap;
  color: $dark;

  & > p {
    margin-bottom: 0;
  }
}

.address {
  margin-right: $spacing;
  position: relative;
  text-overflow: ellipsis;
  overflow: hidden;
}

.store-code {
  margin-left: $spacing * 1.25;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
